import { apiClient } from "../client";
import {
  galleryResponseSchema,
  galleryFilterSchema,
  galleryColumnSchema,
  recentFilesResponseSchema,
} from "./schemas";
import type {
  GalleryRequest,
  GalleryResponse,
  GalleryFilter,
  GalleryColumn,
  RecentFilesResponse,
} from "./types";

export async function getGallery(
  categoryId: string | number,
  request: GalleryRequest
): Promise<GalleryResponse> {
  const response = await apiClient
    .post(`gallery/${categoryId}`, { json: request })
    .json<GalleryResponse>();

  return galleryResponseSchema.parse(response);
}

export async function getGalleryFilters(
  categoryId: string | number
): Promise<GalleryFilter> {
  const response = await apiClient
    .get(`gallery/${categoryId}/filters`, {})
    .json<GalleryFilter>();

  return galleryFilterSchema.parse(response);
}

export async function getGalleryColumns(
  categoryId: string | number
): Promise<GalleryColumn> {
  const response = await apiClient
    .get(`gallery/${categoryId}/columns`, {})
    .json<GalleryColumn>();

  return galleryColumnSchema.parse(response);
}

export async function getRecentFiles(
  page = 1,
  pageSize = 10
): Promise<RecentFilesResponse> {
  const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const response = await apiClient
    .get("gallery/recent", { searchParams: { page, pageSize, timezone } })
    .json<RecentFilesResponse>();

  return recentFilesResponseSchema.parse(response);
}
